import { getServiceURL } from "api/utils"
import { SERVICE_PREFIX } from "utils/constants"
const getPolarisURL = getServiceURL(SERVICE_PREFIX.polaris)
const getSolisURL = getServiceURL(SERVICE_PREFIX.solis)
const getMercuryURL = getServiceURL(SERVICE_PREFIX.mercury)
const getErisURL = getServiceURL(SERVICE_PREFIX.eris)

export const urls = {
  block: {
    list: () => `/user/block/`,
    delete: (id: string | number) => `/user/block/${id}/`,
  },
  user: () => getSolisURL("/v1/users/"),
  config: {
    attributes: () => getSolisURL(`/v1/users/attributes/`),
    preferences: () => getPolarisURL(`/v1/users/settings/`),
  },
  leads: () => getMercuryURL(`/v2/leads/`),
  getUserDetails: () => getSolisURL("/v1/users/fetch/"),
  organizationUser: () => getErisURL("/v1/organizations/users/me/"),
}
